import { defineMessages } from "react-intl";

import { node as patientStatementOfConsentFyrms } from "src/modules/ktx/forms/basic-registration-data/consents/patientStatementOfConsentFyrms";
import { node as patientStatementOfConsentOvsz } from "src/modules/ktx/forms/basic-registration-data/consents/patientStatementOfConsentOvsz";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.consents",
		defaultMessage: "Beleegyező nyilatkozatok"
	}
});

export const node: ParentNode = {
	id: "ktx-consents",
	value: { type: "list", title: messages.title },
	children: [patientStatementOfConsentFyrms, patientStatementOfConsentOvsz]
};
